export const template = `<nav class="nav lg secondary mobile-fullscreen mobile-active">

    <div class="brand">
        <a href="index.html" class="brand">Brand</a>
    </div>

    <div class="menu" id="nav-menu">
        <div class="hamburger"></div>
    </div>

    <!-- LINKS -->
    <ul class="nav-list">
        <li> <a class="active" href="#" class="nav-link">Home</a> </li>
        <li> <a href="#" class="nav-link">About</a> </li>
    </ul>
    <!-- use class 'right' to push the links to the right side, default is: 'left' -->
    <ul class="nav-list right">
        <li class="dropdown">
            <span class="nav-link">Dropdown</span>
            <ul>
                <li class="active"> <a href="#" class="nav-link">dropdown-item</a> </li>
            </ul>
        </li>
    </ul>
    <!-- LINKS -->

    <!-- MOBILE NAVIGATION -->
    <div class="mobile">

        <div class="header">
            <a href="#" class="brand">Brand</a>
        </div>

        <!-- LINKS -->
        <ul class="mobile-list">

            <li> <a href="#" class="nav-link">Home</a> </li>
            <li> <a href="#" class="nav-link">About</a> </li>
            <li class="dropdown expanded">
                <span class="nav-link">Dropdown</span>
                <ul>
                    <li> <a href="#" class="nav-link">dropdown-item</a> </li>
                </ul>
            </li>

        </ul>
        <!-- LINKS -->

        <div class="footer">
            <p>Footer Brand</p>
        </div>

    </div>
    <!-- MOBILE NAVIGATION -->

</nav>`

export const toggle = `<script>
let nav = document.querySelector('.nav')
let menu = document.querySelector('.menu');
let body = document.getElementsByTagName('body')[0];
menu.addEventListener('click', () => {
    nav.classList.toggle('mobile-active');
    body.classList.toggle('nav-active');
});


let mobileNav = document.querySelector('.mobile');
for (let i = 0; i < mobileNav.children[1].querySelectorAll('.dropdown').length; i++) {

    mobileNav.children[1]
        .querySelectorAll('.dropdown')[i]
        .addEventListener('click', () => {
            mobileNav.children[1]
                .querySelectorAll('.dropdown')[i]
                .classList
                .toggle('expanded');
        });

}
</script>`